import { AudioContext as AudioContextModel } from '@shared/models/audioContext';
import { createContext } from 'react';

export const AudioContext = createContext<AudioContextModel>({
  registerManualHandler: () => {},
  unregisterManualHandler: () => {},
  playMessage: () => Promise.resolve(),
});
